// extracted by mini-css-extract-plugin
module.exports = {"Preferences":"Preferences_Preferences__2JYaL","PreferencesItem":"Preferences_PreferencesItem__3_PYw","Disabled":"Preferences_Disabled__1Gxue"};